import React, { useState, forwardRef, useImperativeHandle } from "react";
import Dropzone from "../dropzone/Dropzone";
import "./Upload.css";
import Progress from "../progress/Progress";
import Button from '@material-ui/core/Button';
import PublishIcon from '@material-ui/icons/Publish';
import Auth from '../../../../services/auth';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { acceptedFileTypes } from "../uploadHelper";
import { uploadInboxDocument } from "../../../../services/transcriptionService";
import { LinearProgress, makeStyles, Typography } from "@material-ui/core";
import { useSnackbar } from "notistack";
const auth = new Auth();

const useStyles = makeStyles(() => ({
    errorText: {
        color: '#EF4444',
    },
}));

const CommonUploader = forwardRef(({ caption, onFilesLoaded, disabled }, ref) => {
    const classes = useStyles();
    const [state, setState] = useState({
        files: [],
        uploading: false,
        uploadProgress: {},
        successfullUploaded: false,
    });
    const [failedUpload, setFailedUpload] = useState(false);
    const [loading, setLoading] = useState(false);
    const [uploadErrorMessage, setUploadErrorMessage] = useState(null);
    const { enqueueSnackbar } = useSnackbar();

    useImperativeHandle(ref, () => ({
        clearFiles: clearFiles
    }));

    const onFilesAdded = (files) => {
        files = files.filter(x => acceptedFileTypes.includes(x.type));
        if (onFilesLoaded) onFilesLoaded(files.concat(files));
        setState((prevState) => ({
            ...prevState,
            files: prevState.files.concat(files),
        }));
    };

    const handleUpload = async () => {
        setLoading(true);
        try {
            setState({ ...state, successfullUploaded: true });
        }
        catch (error) {
            enqueueSnackbar("failed to upload files.", { variant: "error" });
            setFailedUpload(true);
        }
        finally {
            setLoading(false);
        }
    };

    const sendRequest = async (file) => {
        try {
            const formData = new FormData();
            formData.append("file", file, file.name);
            formData.append("account", auth.getActiveAccount());
            const result = await uploadInboxDocument(formData);
            if (!result.data) {
                throw new Error("file failed to upload");
            }
        } catch (error) {
            if (error && error.response) {
                setUploadErrorMessage(error.response.data.Message);
            }
            throw new Error("file failed to upload");
        }
    };

    const renderProgress = (file) => {
        const uploadProgress = state.uploadProgress ? state.uploadProgress[file.name] : 0;
        if (loading) {
            return (
                <LinearProgress />
            )
        }
        if (!loading && state.successfullUploaded) {
            return (
                <div className="ProgressWrapper">
                    <Progress progress={uploadProgress ? uploadProgress.percentage : 0} />
                    <div style={{ color: 'rgb(34 197 94)' }}>
                        <CheckCircleOutlineIcon />
                    </div>
                </div>
            );
        }
        if (!loading && failedUpload) {
            return (
                <div className="ProgressWrapper">
                    <Progress progress={uploadProgress ? uploadProgress.percentage : 0} />
                    <div style={{ color: 'rgb(221 35 32)' }}>
                        <HighlightOffIcon />
                    </div>
                </div>
            );
        }
    };

    const renderActions = () => {
        if (state.successfullUploaded || failedUpload) {
            return (
                <Button
                    onClick={clearFiles}
                    color="primary"
                    variant="contained"
                >
                    Clear
                </Button>
            );
        }
    };

    const clearFiles = () => setState({ ...state, files: [], successfullUploaded: false })

    return (
        <div className="Upload">
            <div className="Content">
                <div>
                    <Dropzone
                        caption={caption}
                        onFilesAdded={onFilesAdded}
                        disabled={disabled || loading || state.successfullUploaded}
                    />
                </div>
                <div className="Files">
                    {state.files.map((file) => {
                        return (
                            <div key={file.name} className="Row">
                                <span className="Filename">{file.name}</span>
                                {renderProgress(file)}
                            </div>
                        );
                    })}
                </div>
            </div>
            {uploadErrorMessage ? (
                <Typography class={classes.errorText} variant="subtitle2" gutterBottom>
                    {uploadErrorMessage}
                </Typography>) : null}
            <div className="Actions">
                {state.files.length > 0 ?
                    (
                        <Button
                            onClick={clearFiles}
                            color="primary"
                            variant="contained"
                            disabled={disabled}
                        >
                            Clear
                        </Button>
                    ) : null
                }
            </div>
        </div>
    );
});

export default CommonUploader;



// WEBPACK FOOTER //
// ./src/components/Common/CommonUpload/upload/CommonUploader.js